import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Menu, Segment } from 'semantic-ui-react'
import Header from '../components/Header'
import { Link, withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import AuthenticationStore from '../stores/AuthenticationStore'

@inject('authenticationStore')
@observer
class AuthLayout extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    location: PropTypes.object
  }

  render () {
    const { location, authenticationStore } = this.props
    const { roles } = authenticationStore
    let rolesWidth = 8
    if (!roles['*']) {
      rolesWidth = Object.keys(roles).length + 1
    }
    return (
      <>
        <Header authenticationStore={authenticationStore} />
        <Menu icon='labeled' widths={rolesWidth} className='top-header background-primary-blue' inverted>
          {(roles['*'] || roles.clients) &&
            <Menu.Item
              name='Clients' as={Link} to='/clients'
              active={location.pathname.startsWith('/clients')}
            >
              <Icon name='address book' />
              Clients
            </Menu.Item>}
          {(roles['*'] || roles.calendars) &&
            <Menu.Item
              name='Calendrier' as={Link} to='/calendars'
              active={location.pathname.startsWith('/calendars')}
            >
              <Icon name='calendar alternate' />
              Calendrier
            </Menu.Item>}
          {(roles['*'] || roles.events) &&
            <Menu.Item
              name='Inspections' as={Link} to='/events'
              active={location.pathname.startsWith('/events')}
            >
              <Icon name='clipboard' />
              Inspections
            </Menu.Item>}
          {(roles['*'] || roles.archives) &&
            <Menu.Item
              name='Archives' as={Link} to='/archives'
              active={location.pathname.startsWith('/archives')}
            >
              <Icon name='archive' />
              Archives
            </Menu.Item>}
          {(roles['*'] || roles.emails) &&
            <Menu.Item
              name='Envoi' as={Link} to='/emails'
              active={location.pathname.startsWith('/emails')}
            >
              <Icon name='send' />
              Envoi
            </Menu.Item>}
          {(roles['*'] || roles.users) &&
            <Menu.Item
              name='Utilisateurs' as={Link} to='/users'
              active={location.pathname.startsWith('/users')}
            >
              <Icon name='user' />
              Utilisateurs
            </Menu.Item>}
          {(roles['*'] || roles.roles) &&
            <Menu.Item
              name='Roles' as={Link} to='/roles'
              active={location.pathname.startsWith('/roles')}
            >
              <Icon name='users' />
              Roles
            </Menu.Item>}
          <Menu.Item
            name='Aide' as={Link} to='/help'
            active={location.pathname.startsWith('/help')}
          >
            <Icon name='question' />
            Aide
          </Menu.Item>
        </Menu>
        <Segment basic padded>
          {this.props.children}
        </Segment>
      </>
    )
  }
}

export default withRouter(AuthLayout)
